import { defineMessages } from 'react-intl'

export const templatesPageMessages = defineMessages({
  title: {
    id: 'templatesPage.teamTitle',
    description: 'Templates title on Team page',
    defaultMessage: 'Templates',
  },
  searchPlaceholder: {
    id: 'templatesPage.searchPlaceholder',
    description: 'Common search placeholder on Templates page',
    defaultMessage: 'Search by template name or user name...',
  },
  noTemplatesFoundMessage: {
    id: 'templatesPage.noTemplatesFoundMessage',
    description: 'No templates found message on Team page',
    defaultMessage: 'No templates found',
  },
  uploadedSuccessModalMessage: {
    id: 'templatesPage.uploadedSuccessModalMessage',
    description:
      'Success Modal Message after template upload on Templates page',
    defaultMessage: '<b>{uploadedFilename}</b> uploaded!',
  },
  nameColumn: {
    id: 'templatesPage.nameColumn',
    description: 'Label for table column "name" on Templates page',
    defaultMessage: 'Name',
  },
  uploadedColumn: {
    id: 'templatesPage.uploadedColumn',
    description: 'Label for table column "uploaded" on Templates page',
    defaultMessage: 'Uploaded',
  },
  uploadedByColumn: {
    id: 'templatesPage.uploadedByColumn',
    description: 'Label for table column "uploaded by" on Templates page',
    defaultMessage: 'User',
  },
  versionColumn: {
    id: 'templatesPage.versionColumn',
    description: 'Label for table column "version" on Templates page',
    defaultMessage: 'Version',
  },
  deleteTemplateModalTitle: {
    id: 'templatesPage.deleteTemplateModalTitle',
    description: 'Title for Delete template Modal on Templates page',
    defaultMessage: 'Delete template',
  },
  deleteTemplateModalDescription: {
    id: 'templatesPage.deleteTemplateModalDescription',
    description: 'Description for Delete template Modal on Templates page',
    defaultMessage:
      'Permanently delete {name} template?{br}This action cannot be undone.',
  },
  uploadTemplateButtonLabel: {
    id: 'templatesPage.uploadTemplateButtonLabel',
    description: 'Label for upload template button on Templates page',
    defaultMessage: 'Upload Template',
  },
  uploadTemplateModalTitle: {
    id: 'templatesPage.uploadTemplateModalTitle',
    description: 'Title for upload template modal on Templates page',
    defaultMessage: 'Upload template file',
  },
  uploadTemplateModalDesc: {
    id: 'templatesPage.uploadTemplateModalDesc',
    description: 'Description for upload template modal on Templates page',
    defaultMessage: 'Drag and drop an .rpmConfig file to upload.',
  },
  uploadTemplateResolutionError: {
    id: 'templatesPage.uploadTemplateResolutionError',
    description:
      'Description for upload template resolution error on Templates page',
    defaultMessage:
      'Templates files must end in .rpmConfig. Attempted to upload - {fileName}.',
  },
  uploadTemplateParsingError: {
    id: 'templatesPage.uploadTemplateParsingError',
    description:
      'Description for upload template parsing error on Templates page',
    defaultMessage: 'Error parsing: {message}',
  },
  uploadTemplateZipError: {
    id: 'templatesPage.uploadTemplateZipError',
    description:
      'Description for upload template zipping error on Templates page',
    defaultMessage:
      'Error generating a zip of your template. The template file is possibly larger than your browser supports.',
  },
  uploadTemplateFileError: {
    id: 'templatesPage.uploadTemplateFileError',
    description: 'Description for upload template error on Templates page',
    defaultMessage:
      'Template file upload failed. There may be an issue with your file.',
  },
  uploadTemplateAlreadyAttachedError: {
    id: 'templatesPage.uploadTemplateAlreadyAttachedError',
    description: 'Description for template error on Templates page',
    defaultMessage:
      'This template already is attached to a different job or domain',
  },
})
